module.exports = __webpack_public_path__ + "banquet/components/InventoryRecordDetail/images/email.5a498072e8c8d20303a43ac7e59746f1.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventoryRecordDetail/images/email.png
// module id = 1665
// module chunks = 1